const eventsList = {};

let nextHandle = 0;
const getNextHandle = () => ++nextHandle;

export default {
    subscribe: (eventName: string, callback: (data?) => void): number => {
        if (typeof callback !== 'function') {
            throw new Error('Events.subscribe - Callback is not a function.');
        }

        if (!eventsList[eventName]) {
            eventsList[eventName] = {};
        }

        const handle = getNextHandle();
        eventsList[eventName][handle] = callback;
        return handle;
    },
    unsubscribe: (eventName: string, handle: number): boolean => {
        if (eventsList?.[eventName]?.[handle]) {
            delete eventsList[eventName][handle];
            return true;
        }
        return false;
    },
    trigger: (eventName: string, data: object = {}): boolean => {
        if (!eventsList[eventName] || Object.keys(eventsList[eventName]).length < 1) {
            return false;
        }

        Object.keys(eventsList[eventName]).forEach(handle => {
            eventsList[eventName][handle](data);
        });
        return true;
    },
};
